// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Table } from "../Table/Table";
// import { checkPermission } from "../../screen/redux/api/PermissionManager";
// import moment from "moment";

// const OwnerReq = ({
//   ownersList,
//   pagination,
//   reSend,
//   handlerPopup,
//   setIsViewIdFalied,
//   setPagination,
//   // deleteCoupon={deleteRoom}
//   page,
//   handlerRepay,
//   labels,
//   setPage,
//   setIsActiveStatus,
//   setIsPayoutList,
// }) => {
//   const inputRef = useRef(null);
//   const navigate = useNavigate();
//   // const [page, setPage] = useState(1);

//   const [owners, setOwners] = useState(ownersList);
//   useEffect(() => {
//     setOwners(ownersList);
//   }, [ownersList]);
//   console.log("ownersList", ownersList);
//   const columns = React.useMemo(() => {
//     let d = [
//       {
//         Header: "S.No",
//         accessor: "",
//         Cell: ({ value, row }) => {
//           return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
//         },
//       },
//       {
//         Header: "Created By",
//         accessor: "owner_name",
//         Cell: ({ value, row }) => {
//           const property = row.original;
//           console.log("DASDL", property);
//           return (
//             <>
//               <p className="text-nowrap">{value ? `${value} ` : "-"}</p>
//               <p style={{ fontSize: 12, color: "#adadad" }}>
//                 {row.original?.created_at
//                   ? `${moment(row.original?.created_at).format(
//                       "DD-MM-YYYY hh:mm A"
//                     )}`
//                   : ""}
//               </p>
//             </>
//           );
//         },
//       },
//       {
//         Header: "Amount",
//         accessor: "amount",
//         Cell: ({ value, row }) => {
//           return (
//             <>
//               <p className="text-nowrap">{value ? `${value} ` : "-"}</p>{" "}
//             </>
//           );
//         },
//       },

//       {
//         Header: "Status",
//         accessor: "status_display",
//         Cell: ({ value, row }) => {
//           return (
//             <div
//               style={{
//                 background:
//                   value === "Failed"
//                     ? "#F52E2E"
//                     : value === "Processed"
//                     ? "#9A36E6"
//                     : "#adadadad",
//                 borderRadius: 10,
//                 width: 154,
//               }}
//             >
//               <p
//                 style={{
//                   color: "#fff",
//                   margin: 0,
//                   textAlign: "center",
//                   paddingLeft: 10,
//                   paddingRight: 10,
//                   paddingTop: 5,
//                   paddingBottom: 5,
//                 }}
//               >
//                 {value}
//               </p>
//             </div>
//           );
//         },
//       },
//     ];
//     console.log("labels", labels);

//     let processed = [
//       {
//         Header: "Transaction ID",
//         accessor: "rz_payout_id",
//         Cell: ({ value, row }) => {
//           const item = row.original;
//           return (
//             <>
//               <p className="text-nowrap">{value ? `${value} ` : "-"}</p>{" "}
//             </>
//           );
//         },
//       },
//       {
//         Header: "Description",
//         accessor: "description",
//         Cell: ({ value, row }) => {
//           const item = row.original;
//           return (
//             <>
//               <p className="text-nowrap">{value ? `${value} ` : "-"}</p>{" "}
//             </>
//           );
//         },
//       },
//     ];
//     let rejectView = {
//       Header: "Description",
//       accessor: "description",
//       Cell: ({ value, row }) => {
//         const item = row.original;
//         return (
//           <>
//             <p className="text-nowrap">{value ? `${value} ` : "-"}</p>{" "}
//           </>
//         );
//       },
//     };
//     let action = {
//       Header: "Description",
//       accessor: "",
//       Cell: ({ row }) => {
//         const item = row.original;

//         return (
//           <>
//             <div
//               style={{
//                 display: "flex",
//                 gap: 10,
//               }}
//             >
//               <div
//                 onClick={() => {
//                   handlerPopup(true);
//                   setIsViewIdFalied(item);
//                   setIsActiveStatus("procced");
//                 }}
//                 style={{
//                   background: "#9A36E6",
//                   borderRadius: 10,
//                   width: 85,
//                   cursor: "pointer",
//                 }}
//               >
//                 <p
//                   style={{
//                     color: "#fff",
//                     margin: 0,
//                     textAlign: "center",
//                     padding: "5px 10px",
//                   }}
//                 >
//                   Procced
//                 </p>
//               </div>
//               <div
//                 onClick={() => {
//                   handlerPopup(true);
//                   setIsViewIdFalied(item);
//                   setIsActiveStatus("reject");
//                 }}
//                 style={{
//                   background: "#e63636ff",
//                   borderRadius: 10,
//                   width: 85,
//                   cursor: "pointer",
//                 }}
//               >
//                 <p
//                   style={{
//                     color: "#fff",
//                     margin: 0,
//                     textAlign: "center",
//                     padding: "5px 10px",
//                   }}
//                 >
//                   Reject
//                 </p>
//               </div>
//             </div>
//           </>
//         );
//       },
//     };
//     const hasPendingStatus = labels.label.toLowerCase() === "pending";
//     const hasProcessedStatus = labels.label.toLowerCase() === "processed";
//     const hasFailedStatus = labels.label.toLowerCase() === "failed";
//     const shouldShowAction =
//       checkPermission("CAN-EDIT-WALLET_TRANSACTION") && hasPendingStatus;
//     const shouldShowProcessed =
//       checkPermission("CAN-EDIT-WALLET_TRANSACTION") && hasProcessedStatus;
//     const shouldShowFailed =
//       checkPermission("CAN-EDIT-WALLET_TRANSACTION") && hasFailedStatus;
//     return shouldShowAction
//       ? [...d, action]
//       : shouldShowProcessed
//       ? [...d, ...processed]
//       : shouldShowFailed
//       ? [...d, rejectView]
//       : d;

//     // return checkPermission("CAN-EDIT-WALLET_TRANSACTION") ? [...d, action] : d;
//   }, [page, labels]);

//   return (
//     <div>
//       <Table
//         columns={columns}
//         setPageno={setPage}
//         pagecount={pagination}
//         data={owners}
//         show={true}
//       />
//     </div>
//   );
// };

// export default OwnerReq;
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "../Table/Table";
import { checkPermission } from "../../screen/redux/api/PermissionManager";
import moment from "moment";
import { view_icon } from "../../assets/img";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";

const OwnerReq = ({
  ownersList,
  pagination,
  reSend,
  handlerPopup,
  setIsViewIdFalied,
  setPagination,
  page,
  handlerRepay,
  labels,
  setPage,
  setIsActiveStatus,
  setIsPayoutList,
}) => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [openPop, setOpenPop] = useState(false);
  const [owners, setOwners] = useState(ownersList);
  useEffect(() => {
    setOwners(ownersList);
  }, [ownersList]);
  console.log("ownersList", ownersList);

  const columns = React.useMemo(() => {
    // Base columns without Status
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "Created By",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          const property = row.original;
          console.log("DASDL", property);
          return (
            <>
              <p className="text-nowrap">{value ? `${value} ` : "-"}</p>
              <p style={{ fontSize: 12, color: "#adadad" }}>
                {row.original?.created_at
                  ? `${moment(row.original?.created_at).format(
                      "DD-MM-YYYY hh:mm A",
                    )}`
                  : ""}
              </p>
            </>
          );
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          return (
            <>
              <p className="text-nowrap">{value ? `${value} ` : "-"}</p>{" "}
            </>
          );
        },
      },
    ];

    console.log("labels", labels);

    let processed = [
      {
        Header: "Transaction ID",
        accessor: "rz_payout_id",
        Cell: ({ value, row }) => {
          const item = row.original;
          return (
            <>
              <p className="text-nowrap">{value ? `${value} ` : "-"}</p>{" "}
            </>
          );
        },
      },
      {
        Header: "Description",
        accessor: "description",
        Cell: ({ value, row }) => {
          const item = row.original;
          console.log("vvvvvvvvvvvvvvvv", value);

          return (
            <>
              <p
                className="line-clamp-3 break-all"
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 7,
                  WebkitBoxOrient: "vertical",
                  wordBreak: "break-all",
                }}
              >
                {value || "-"}
              </p>
              {/* <p className="text-nowrap">{value ? `${value} ` : "-"}</p>{" "} */}
            </>
          );
        },
      },
      {
        Header: "Action",
        accessor: "property_id",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                <button
                  onClick={() => {
                    setOpenPop(row.original);
                  }}
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className="mx-2 edit-btn " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ];

    let rejectView = {
      Header: "Description",
      accessor: "description",
      Cell: ({ value, row }) => {
        const item = row.original;
        return (
          <>
            <p
              className="line-clamp-3 break-all"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 7,
                WebkitBoxOrient: "vertical",
                wordBreak: "break-all",
              }}
            >
              {value ? `${value} ` : "-"}
            </p>{" "}
          </>
        );
      },
    };

    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ row }) => {
        const item = row.original;

        return (
          <>
            <div
              style={{
                display: "flex",
                gap: 10,
              }}
            >
              <div
                onClick={() => {
                  handlerPopup(true);
                  setIsViewIdFalied(item);
                  setIsActiveStatus("procced");
                }}
                style={{
                  background: "#9A36E6",
                  borderRadius: 10,
                  width: 85,
                  cursor: "pointer",
                }}
              >
                <p
                  style={{
                    color: "#fff",
                    margin: 0,
                    textAlign: "center",
                    padding: "5px 10px",
                  }}
                >
                  Procced
                </p>
              </div>
              {/* <div
                onClick={() => {
                  handlerPopup(true);
                  setIsViewIdFalied(item);
                  setIsActiveStatus("reject");
                }}
                style={{
                  background: "#e63636ff",
                  borderRadius: 10,
                  width: 85,
                  cursor: "pointer",
                }}
              >
                <p
                  style={{
                    color: "#fff",
                    margin: 0,
                    textAlign: "center",
                    padding: "5px 10px",
                  }}
                >
                  Reject
                </p>
              </div> */}
            </div>
          </>
        );
      },
    };

    // Status column definition
    const statusColumn = {
      Header: "Status",
      accessor: "status_display",
      Cell: ({ value, row }) => {
        return (
          <div
            style={{
              background:
                value === "Failed"
                  ? "#F52E2E"
                  : value === "Processed"
                    ? "#9A36E6"
                    : "#adadadad",
              borderRadius: 10,
              width: 154,
            }}
          >
            <p
              style={{
                color: "#fff",
                margin: 0,
                textAlign: "center",
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 5,
                paddingBottom: 5,
              }}
            >
              {value}
            </p>
          </div>
        );
      },
    };

    const hasPendingStatus = labels.label.toLowerCase() === "pending";
    const hasProcessedStatus = labels.label.toLowerCase() === "processed";
    const hasFailedStatus = labels.label.toLowerCase() === "failed";
    const shouldShowAction =
      checkPermission("CAN-EDIT-WALLETOWNER") && hasPendingStatus;
    const shouldShowProcessed =
      checkPermission("CAN-EDIT-WALLETOWNER") && hasProcessedStatus;
    const shouldShowFailed =
      checkPermission("CAN-EDIT-WALLETOWNER") && hasFailedStatus;

    // Build columns array
    if (shouldShowAction) {
      // For Pending: Status first, then Action last
      return [...d, statusColumn, action];
    } else if (shouldShowProcessed) {
      // For Processed: Status last
      return [...d, ...processed, statusColumn];
    } else if (shouldShowFailed) {
      // For Failed: Status last
      return [...d, rejectView, statusColumn];
    } else {
      return [...d, statusColumn];
    }
  }, [page, labels]);

  const downloadImage = async (url) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = url.split("/").pop(); // file name
      link.click();

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Image download failed:", error);
    }
  };

  return (
    <div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
      {Boolean(openPop) && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <CloseSharpIcon
                onClick={() => {
                  setOpenPop(false);
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-4">
              <div className="col-md-12">
                <div
                  className=" mb-2 w-100 d-flex ac-jc"
                  style={{ width: "auto", height: "220px" }}
                >
                  <img
                    src={openPop?.proof}
                    className="img-popup"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex ac-jc px-2 mt-5">
              <button
                onClick={() => {
                  downloadImage(openPop?.proof);
                }}
                className="submit-btn f2 w-40"
              >
                Download
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OwnerReq;
